<template>
  <v-layout wrap class="custom-header">
    <header-values
      v-for="(item, index) in items"
      :key="index"
      v-bind="item"></header-values>
  </v-layout>
</template>

<script>
import HeaderValues from "@/components/shared/framework/cards/HeaderValues.vue"

export default {
  name: "HomeHeader",
  components: {
    HeaderValues,
  },
  data() {
    return {
      //
    }
  },
  computed: {
    iconPath() {
      if (
        this.$store?.state?.user?.profile &&
        this.$store?.state?.user?.profile?.imgUrl !== false
      ) {
        return this.$store.state.user.profile.imgUrl
      }
      return require("@/assets/icons/defaultProfileImg.png").default
    },
    items() {
      return [
        {
          layout: "left-side",
        },
        {
          component: { name: "MultiTeamSelect", params: {} },
          layout: "middle",
        },
        {
          icon: {
            path: this.iconPath,
          },
          route: { link: "/profile-info" },
          layout: "right-side img-circle",
        },
      ]
    },
  },
}
</script>

<style scoped lang="sass">
@import '@/assets/sass/globals.sass'
.custom-header
  background-color: #1F244D
</style>
